import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Backdrop from "@mui/material/Backdrop";
import Typography from "@mui/material/Typography";
import Animation_Success_animation from "./ServicesOperationComponent/Helper/Animation_Success_animation";

export const ModalConfirmEventos_ServicesOperation = ({
  open,
  CerrarModal,
  icon,
  message,
  message2,
  success,
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: 24,
    p: 4,
    borderRadius: "16px",
    border: "1px solid",
    borderColor:
      success === true ? "#2E7D3280" : success === false ? "#FED7D7" : "none",

    borderTop:
      success === true
        ? "5px solid #2E7D32"
        : success === false
          ? "5px solid #D32F2F"
          : "none",
  };
  const handleCloseModal = (event) => {
    event.stopPropagation(); // Detiene la propagación del evento
    CerrarModal(event); // Llama a la función original de cerrar el modal
  };
  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleCloseModal}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            {icon}
            <Typography
              id="transition-modal-description"
              sx={{
                mt: 2,
                textAlign: "center",
                color: "#1A202C",
                fontWeight: 600,
                fontSize: "18px",
              }}
            >
              {message}
            </Typography>
            <Typography
              id="transition-modal-description2"
              sx={{
                mt: 2,
                textAlign: "center",
                fontWeight: 400,
                fontSize: "14px",
                color: "#718096",
              }}
            >
              {message2}
            </Typography>

            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={(e) => CerrarModal(e)}
              sx={{
                marginTop: "20px",
                backgroundColor: "#002878",
                color: "#fff",
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "24px",
                letterSpacing: "0.15px",
                width: "180px",
                borderRadius: "4px",
                "&:hover": {
                  backgroundColor: "#002878",
                  color: "#fff",
                },
              }}
            >
              Volver al inicio
            </Button>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};
